<section class="automaticDebitSection" id="automaticDebitSection">
  <div class="automaticDebitBackdrop" id="automaticDebitBackdrop"></div>
  <app-select-debit
    *ngIf="step === 1"
    class="automaticDebitModal"
    (changeStep)="step = $event"
    (sendEntitys)="entitys = $event"
    (setAutoDebitAccount)="setAutoDebitAccount.emit($event)"
    (setAutoDebitAccountImage)="setAutoDebitAccountImage.emit($event)"
    (changeAutomaticDebit)="changeAutomaticDebit.emit($event)"
    [visbleCancel]="visbleCancel"
  />
  <app-add-debit
    *ngIf="step === 2"
    class="automaticDebitModal"
    (changeStep)="step = $event"
    [entitys]="entitys"
    (setAutoDebitAccount)="setAutoDebitAccount.emit($event)"
    (setAutoDebitAccountImage)="setAutoDebitAccountImage.emit($event)"
    (changeAutomaticDebit)="changeAutomaticDebit.emit($event)"
  />
</section>
